import { EntityAuditTrailDescriptor } from 'pages/audit-trail/entity/entityAuditTrail';
import { useGetMatterAuditTrailAuthorsQuery, useLazyGetMatterAuditTrailEntriesQuery } from 'store/api/audit-trail';

/** Cases have no access log, so the drawer offers no "Opened" category; time and expenses are opt-in. */
export const MATTER_AUDIT_TRAIL: EntityAuditTrailDescriptor = {
    localeNamespace: 'audit-trail.matter',
    classifierCodes: [
        'MATTER_STATE_TYPE',
        'MATTER_TYPE',
        'OFFER_VALUE_TYPE',
        'ENGAGEMENT_LENGTH_UNIT',
        'REASON_OFFER_LOST',
        'ARCHIVING_PROPERTIES_TYPE',
        'PRICING_LIMITATION_TYPE',
        'CAP_UNIT_TYPE',
        'INVOICING_INTERVAL_TYPE',
        'ACCOUNTING_REVENUE_TYPE',
        'REMUNERATION_CALC_TYPE',
        'MATTER_BLOCKING_POLICY_TYPE',
        'MATTER_EMPLOYEE_ROLE_TYPE',
        'MATTER_PARTY_ROLE_TYPE',
    ],
    categories: ['FIELD_CHANGES', 'STATUS_CHANGES', 'STRUCTURAL_CHANGES', 'TIME_AND_EXPENSES'],
    paramClassifiers: {
        employeeRoleCode: { classifierCode: 'MATTER_EMPLOYEE_ROLE_TYPE', as: 'role' },
        partyRoleCode: { classifierCode: 'MATTER_PARTY_ROLE_TYPE', as: 'role' },
    },
    useLazyEntriesQuery: useLazyGetMatterAuditTrailEntriesQuery,
    useAuthorsQuery: useGetMatterAuditTrailAuthorsQuery,
};
